export enum MarketLevelType {
  'Nacional' = 1,
  'Metro' = 2,
  'Big' = 3,
  'Small' = 4,
  'Super Small' = 5
}
